import { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoaderContext } from "../../../../App";
import EmissionFactorService from "../../../../core/service/EmissionFactorService";
import './LinkEmissionFactor.scss';

const LinkEmissionFactor = ({ t, filter, dataPointId, handleEFCallback, linkType }) => {
	const [activeScope, setActiveScope] = useState('Scope 1');
	const [emissionTable, setEmissionTable] = useState('DEFRA');
	const [categories, setCategories] = useState([]);
	const [selectedCat, setSelectedCat] = useState(0);
	const [materials, setMaterials] = useState([{
		level1: '',
		level2: '',
		level3: '',
		level4: '',
		level5: '',
	}]);
	const [materialsOptions, setMaterialsOptions] = useState({
		level1: [],
		level2: [],
		level3: [],
		level4: [],
		level5: [],
	});
	const [dbData, setDBData] = useState([]);
	const [disabledMatRows, setDisabledMatRows] = useState({});
	const [validation, setValidation] = useState({});
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [savedValues, setSavedValues] = useState({});

	useEffect(() => {
		getDBData();
		getEFLinking();
	}, []);

	useEffect(() => {
		getCats(activeScope);
	}, [activeScope]);

	useEffect(() => {
		if (selectedCat === 0) return;
		const r = {
			index: 0,
			level: 1,
			level1: '',
			level2: '',
			level3: '',
			level4: '',
			level5: '',
		};
		getLevels(r, categories?.find(c => c.id === selectedCat));
	}, [selectedCat, emissionTable]);

	const onScopeChange = (scope) => {
		setMaterialsOptions({
			level1: [],
			level2: [],
			level3: [],
			level4: [],
			level5: [],
		});
		setSelectedCat(0);
		setActiveScope(scope);
	};

	const getDBData = () => {
		EmissionFactorService.getDB().then(res => {
			if (res.status !== 200) return;

			setDBData(res.data.data ?? []);
			if (res.data.data?.length > 0) {
				setEmissionTable(res.data.data[0]);
			}
		}).catch(err => { });
	};

	const getCats = (scope) => {
		EmissionFactorService.getCategories(scope).then(res => {
			if (res.status !== 200) return;
			setCategories(res.data.data);
		}).catch(err => { });
	};

	const savedDataView = () => {
		return (
			<div className="carbonEmissionCalculator_header">
				{
					savedValues &&
					<div style={{ textAlign: "left" }}>
						<label><b>Type: </b>{savedValues.scope}</label> | &nbsp;
						<label><b>Emission Table: </b>{savedValues.db}</label> | &nbsp;
						<label><b>Source: </b>{savedValues.category}</label> | &nbsp;
						<label><b>Level 1: </b>{savedValues.level1}</label> | &nbsp;
						<label><b>Level 2: </b>{savedValues.level2}</label> | &nbsp;
						<label><b>Level 3: </b>{savedValues.level3}</label>
					</div>
				}
				{
					!savedValues &&
					<label>
						No emission factor linked
					</label>
				}
			</div>
		)
	}

	const renderHeader = () => {
		return (
			<div className="carbonEmissionCalculator_header">
				<div>
					<Button variant={activeScope === 'Scope 1' ? 'primary' : 'secondary border-0'}
						onClick={() => onScopeChange('Scope 1')}
						className="sbmBtn mx-2 px-4">
						Scope 1
					</Button>
					<Button variant={activeScope === 'Scope 2' ? 'primary' : 'secondary border-0'}
						onClick={() => onScopeChange('Scope 2')}
						className="sbmBtn mx-2 px-4">
						Scope 2
					</Button>
					<Button variant={activeScope === 'Scope 3' ? 'primary' : 'secondary border-0'}
						onClick={() => onScopeChange('Scope 3')}
						className="sbmBtn mx-2 px-4">
						Scope 3
					</Button>
				</div>
				<div className="Emission_Table_Fillter">
					<ul>
						<li>
							<label htmlFor="emissionTable">{t("EmissionTable.label")}</label>
							<select id="emissionTable"
								className="form-select"
								onChange={(e) => setEmissionTable(e.target.value)}
								required
								value={emissionTable}>
								{
									dbData.map(d => {
										return <option key={d} value={d}>{d}</option>;
									})
								}
							</select>
						</li>
					</ul>
				</div>
			</div>
		)
	};

	const renderCategories = () => {
		return (
			<div>
				<h6>{t('SelectEmissionSource.label')}</h6>
				<div className="list_SelectEmissionSource">
					{
						categories?.map(cat => {
							return (
								<div className={`Single_EmissionSource_card  ${selectedCat === cat.id ? 'EmissionSource-selected' : ''}`}
									onClick={() => onCatSelect(cat)}>
									<div className="cat-icon">
										<img src={require(`../../../../images/emission/${cat.icon}`)} />
									</div>
									{cat.category}
								</div>
							);
						})
					}
				</div>
				{selectedCat > 0 && <p>{categories?.find(cat => cat.id === selectedCat)?.description}</p>}
			</div>
		);
	};

	const onCatSelect = (cat) => {
		setSelectedCat(cat.id);
	};

	const renderMaterialFormRow = (material, index) => {
		return (
			<Form validated={validation[index] === true}>
				<div className="d-flex material-row my-2" id={`matRow-${index}`} key={`matRow-${index}`}>
					{renderLevel1Field(material, index)}
					{renderLevel2Field(material, index)}
					{renderLevel3Field(material, index)}
					{renderLevel4To5Field(material, index)}
				</div>
			</Form>
		);
	};

	const renderMaterialsQuantity = () => {
		if (selectedCat === 0) return <></>;

		return (
			<div className="mt-4">
				<h6>{t("QuantityOfMaterials.label")}</h6>
				<div className="mt-4">
					<div className="d-flex">
						<div className="w-10 mx-2">{t("Level1.label")}</div>
						<div className="w-10 mx-2">{t("Level2.label")}</div>
						<div className="w-10 mx-2">{t("Level3.label")}</div>
						<div className="w-15 mx-2">{t("Level45.label")}</div>
					</div>
					{
						materials?.map((material, index) => {
							return renderMaterialFormRow(material, index);
						})
					}
				</div>
			</div>
		)
	};

	const renderLevel1Field = (material, index) => {
		return (
			<div className="w-10 mx-2">
				{
					<select
						className="form-select"
						onChange={(e) => onLevel1Change(e.target.value, index)}
						required={true}
						value={material.level1}>
						<option key='' value='' hidden>{t('Select.label')}</option>
						{
							materialsOptions.level1?.length > 0 &&
							materialsOptions.level1[index]?.map((l, lindex) => {
								return (
									<option value={l} key={`level1-${index}-${lindex}`}>{l}</option>
								);
							})
						}
					</select>
				}
			</div>
		)
	};

	const renderLevel2Field = (material, index) => {
		return (
			<div className="w-10 mx-2">
				{
					<select
						className="form-select"
						onChange={(e) => onLevel2Change(e.target.value, index)}
						required={true}
						value={material.level2}>
						<option key='' value='' hidden>{t('Select.label')}</option>
						{
							materialsOptions.level2?.length > 0 &&
							materialsOptions.level2[index]?.map((l, lindex) => {
								return <option value={l} key={`level2-${index}-${lindex}`}>{l}</option>;
							})
						}
					</select>
				}
			</div>
		);
	};

	const renderLevel3Field = (material, index) => {
		return (
			<div className="w-10 mx-2">
				{
					<select
						className="form-select"
						onChange={(e) => onLevel3Change(e.target.value, index)}
						required={true}
						value={material.level3}>
						<option key='' value='' hidden>{t('Select.label')}</option>
						{
							materialsOptions.level3?.length > 0 &&
							materialsOptions.level3[index]?.map((l, lindex) => {
								return <option value={l} key={`level3-${index}-${lindex}`}>{l}</option>;
							})
						}
					</select>
				}
			</div>
		);
	};

	const renderLevel4To5Field = (material, index) => {
		return (
			<div className="w-15 mx-2">
				<div className="d-flex w-100">
					<div className="w-50 me-1">
						{
							<select
								className="form-select"
								onChange={(e) => onLevel4Change(e.target.value, index)}
								required={true}
								value={material.level4}>
								<option key='' value='' hidden>{t('Select.label')}</option>
								{
									materialsOptions.level4?.length > 0 &&
									materialsOptions.level4[index]?.map((l, lindex) => {
										return <option value={l} key={`level4-${index}-${lindex}`}>{l}</option>;
									})
								}
							</select>
						}
					</div>
					<div className="w-50">
						{
							<select
								className="form-select"
								onChange={(e) => onLevel5Change(e.target.value, index)}
								required={true}
								value={material.level5}>
								<option key='' value='' hidden>{t('Select.label')}</option>
								{
									materialsOptions.level5?.length > 0 &&
									materialsOptions.level5[index]?.map((l, lindex) => {
										return <option value={l} key={`level4-${index}-${lindex}`}>{l}</option>;
									})
								}
							</select>
						}
					</div>
				</div>
			</div>
		);
	};

	const onLevel1Change = (val, index) => {
		const row = {
			index: index,
			level: 2,
			level1: val,
			level2: '',
			level3: '',
			level4: '',
			level5: ''
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level1 = val;
		matData[index].level2 = '';
		matData[index].level3 = '';
		matData[index].level4 = '';
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		const cat = categories?.find(cat => cat.id === selectedCat);
		getLevels(row, cat);
	};

	const onLevel2Change = (val, index) => {
		const row = {
			index: index,
			level: 3,
			level1: materials[index].level1,
			level2: val,
			level3: '',
			level4: '',
			level5: '',
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level2 = val;
		matData[index].level3 = '';
		matData[index].level4 = '';
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		const cat = categories?.find(cat => cat.id === selectedCat);
		getLevels(row, cat);
	};

	const onLevel3Change = (val, index) => {
		const row = {
			index: index,
			level: 4,
			level1: materials[index].level1,
			level2: materials[index].level2,
			level3: val,
			level4: '',
			level5: '',
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level3 = val;
		matData[index].level4 = '';
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		const cat = categories?.find(cat => cat.id === selectedCat);
		getLevels(row, cat);
	};

	const onLevel4Change = (val, index) => {
		const row = {
			index: index,
			level: 5,
			level1: materials[index].level1,
			level2: materials[index].level2,
			level3: materials[index].level3,
			level4: val,
			level5: '',
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level4 = val;
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		const cat = categories?.find(cat => cat.id === selectedCat);
		getLevels(row, cat);
	};

	const onLevel5Change = (val, index) => {
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level5 = val;
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
	};

	const getLevels = (row, cat) => {
		EmissionFactorService.getLevels({
			db: emissionTable,
			scope: activeScope,
			category: cat?.category,
			level: row.level,
			level1: row.level1,
			level2: row.level2,
			level3: row.level3,
			level4: row.level4,
			level5: row.level5,
		}).then(res => {
			if (res.status !== 200) return;

			const options = res.data.data;
			setMaterialsOptions(moptions => {
				const matOptions = JSON.parse(JSON.stringify(moptions));
				if (row.level === 1) {
					matOptions.level1[row.index] = options;
				} else if (row.level === 2) {
					matOptions.level2[row.index] = options;
				} else if (row.level === 3) {
					matOptions.level3[row.index] = options;
				} else if (row.level === 4) {
					matOptions.level4[row.index] = options;
				} else if (row.level === 5) {
					matOptions.level5[row.index] = options;
				}
				return matOptions;
			});
		}).catch(err => { });
	};

	const renderFooter = () => {
		return (
			<div className="p-2">
				<Button variant="secondary" onClick={() => { handleEFCallback(true) }}
					className="sbmBtn mx-2 px-5">
					{t("Discard.label")}
				</Button>
				<Button variant="primary" onClick={() => { updateEFLinking() }}
					className="sbmBtn mx-2 px-5">
					{t("LinkEmissionFactor.label")}
				</Button>
			</div>
		)
	}

	const updateEFLinking = () => {
		if (!materials[0].level1 || !materials[0].level2 || !materials[0].level3) {
			validateRows(0);
			return;
		}
		const matData = JSON.parse(JSON.stringify(materials));
		const cat = categories?.find(cat => cat.id === selectedCat);
		let passData = {
			db: emissionTable,
			scope: activeScope,
			category: cat.category,
			level1: matData[0].level1,
			level2: matData[0].level2,
			level3: matData[0].level3,
			level4: matData[0].level4,
			level5: matData[0].level5,
		}
		setLoaderDisplay(true);
		if (linkType == 'dp') {
			EmissionFactorService.linkEmissionFactorDP(dataPointId, passData).then(res => {
				setLoaderDisplay(false);
				if (res.status !== 200) return;
				toast.success("Success", {
					position: toast.POSITION.TOP_RIGHT,
				});
				handleEFCallback(true);
			}).catch(err => { setLoaderDisplay(false); });
		} else if (linkType == 'metric') {
			EmissionFactorService.linkEmissionFactorMetric(dataPointId, passData).then(res => {
				setLoaderDisplay(false);
				if (res.status !== 200) return;
				toast.success("Success", {
					position: toast.POSITION.TOP_RIGHT,
				});
				handleEFCallback(true);
			}).catch(err => { setLoaderDisplay(false); });
		}

	}

	const validateRows = (index) => {
		const validationClone = JSON.parse(JSON.stringify(validation));
		validationClone[index] = true;
		setValidation(validationClone);
	};

	const getEFLinking = () => {
		if (linkType == 'dp') {
			EmissionFactorService.getEFLinkingDP(dataPointId).then(res => {
				if (res.status !== 200) return;
				if (res.data.data) {
					setSavedValues(res.data.data);
				} else {
					setSavedValues(null);
				}
			}).catch(err => { });
		} else if (linkType == 'metric') {
			EmissionFactorService.getEFLinkingMetric(dataPointId).then(res => {
				if (res.status !== 200) return;
				if (res.data.data) {
					setSavedValues(res.data.data);
				} else {
					setSavedValues(null);
				}
			}).catch(err => { });
		}
	}

	const setDataToEdit = (data) => {
		setEmissionTable(data.db);
		setActiveScope(data.scope);
		let cat = categories?.find(cat => cat.category === data.category);
		setSelectedCat(cat.id);
	}

	return (
		<div id='carbonEmissionCalculator' className="mt-3 card carbonEmissionCalculator_Card">
			{savedDataView()}
			{renderHeader()}
			<div className="p-4">
				<div className="text-muted">
					{activeScope === 'Scope 1' && <p>{t('Scope1Definition.label')}</p>}
					{activeScope === 'Scope 2' && <p>{t('Scope2Definition.label')}</p>}
					{activeScope === 'Scope 3' && <p>{t('Scope3Definition.label')}</p>}
					{renderCategories()}
					{renderMaterialsQuantity()}
					{renderFooter()}
				</div>
			</div>
		</div>
	)
}
LinkEmissionFactor.propTypes = {};
export default withTranslation()(LinkEmissionFactor);
